import { Injectable } from '@angular/core';

import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@core/services/api/api.service';
import { PublicDataService } from '@core/services/public-data/public-data.service';

import { GeneralUtilService } from '../utils/general-util.service';

@Injectable({
  providedIn: 'root'
})
export class CardAdditionalService {
  constructor(
    private apiService: ApiService,
    private publicDataService: PublicDataService
  ) {}

  /**
   * Получение данных для переоткрытия карты
   */
  public getReopenCardData(productCode: string): Observable<{
    docSettings: any[];
    cities: any[];
    availableTypes: any[];
    branches: any[];
  }> {
    return forkJoin([
      this.loadReopenCardData({}),
      this.publicDataService.getServiceData('city'),
      this.loadAvailableTypesForReopenCardByProductCode(productCode),
      this.getBranches()
    ]).pipe(
      map(([res, cities, availableTypes, branches]) => {
        return {
          docSettings: (res as { docSettings }).docSettings,
          cities,
          availableTypes,
          branches
        };
      })
    );
  }

  /**
   * Получение причин для переоткрытия карты
   */
  public getReopenCardReasons(codeMain: string, codeAdd: string): Observable<any[]> {
    return this.apiService.get('rest/personal/reopen_card_reason', {
      params: {
        codeMain,
        codeAdd
      }
    });
  }

  /**
   * Загрузка доступных типов карт для переоткрытия
   */
  public loadAvailableTypesForReopenCardByProductCode(code: string): Observable<any[]> {
    return this.apiService.get('rest/personal/prog_card/dic', {
      params: {
        code
      }
    });
  }

  /**
   * Загрузка данных для переоткрытия карты
   */
  public loadReopenCardData(data?: any): Observable<any> {
    return this.apiService.post(`rest/personal/request/process/fl_request_reopen_card`, data);
  }

  /**
   * Получение филиалов
   */
  public getBranches(): Observable<any[]> {
    return this.apiService
      .get('rest/personal/request/process/fl_request_open_card/info/branches')
      .pipe(map((res: { bankBranch: any[] }) => GeneralUtilService.getArray(res.bankBranch)));
  }

  /**
   * Получение сертификата для изменения ПИН-кода
   */
  public getCertificateForChangePin(): Observable<string> {
    return this.apiService.get('rest/personal/crypto/certificate/pin').pipe(
      map((res: any) => {
        return res.publicKey;
      })
    );
  }

  /**
   * Изменение ПИН-кода карты
   */
  public changeCardPin(data: {
    cardId: string;
    encryptedPin: string;
  }): Observable<{ bpcResponseCode: string; bpcMessage: string }> {
    return this.apiService.post('rest/personal/crypto/change/pin', data);
  }

  /**
   * Проверка доступности мобильного кошелька
   */
  public checkMobileWallet(): Observable<{ available: boolean; type: string }> {
    return of({ available: false, type: '' });
  }

  /**
   * Доступно ли повышение брокерского счета
   */
  public availableForUpBrokerAccount(number: string): boolean {
    if (RegExp('^42301').test(number) || RegExp('^42601').test(number)) return true;
    if (RegExp('^423').test(number) || RegExp('^426').test(number)) return false;

    return true;
  }

  /**
   * Проверка на брокерский счет
   */
  public checkOnBrokerAccount(number: string): boolean {
    return /^3060(1|6)/.test(number);
  }

  /**
   * Проверка на залоговый счет
   */
  public checkOnCollateralAccount(productSubType: string): boolean {
    return productSubType === '12';
  }
}
